module.exports = __webpack_public_path__ + "img/blacklist.16e9ca07.gif";